var map = {
	"./announcements": "7de2",
	"./announcements.ts": "7de2",
	"./assessmentStateIcons": "d3bd",
	"./assessmentStateIcons.ts": "d3bd",
	"./assistant.png": "b2ff",
	"./classroom.png": "8796",
	"./classroom_sync.png": "27c1",
	"./coursePrivilegeIcons": "ac5d",
	"./coursePrivilegeIcons.ts": "ac5d",
	"./courseTreeNodeTypeIcons": "ea21",
	"./courseTreeNodeTypeIcons.ts": "ea21",
	"./eventStateIcons": "2a44",
	"./eventStateIcons.ts": "2a44",
	"./evo.png": "41bd",
	"./evo_classroom.png": "3e7e",
	"./exerciseStatesIcons": "af55",
	"./exerciseStatesIcons.ts": "af55",
	"./exerciseTestCaseTypeIcons": "612c",
	"./exerciseTestCaseTypeIcons.ts": "612c",
	"./exerciseTypesIcons": "dad4",
	"./exerciseTypesIcons.ts": "dad4",
	"./google.png": "cebc",
	"./hero-bg.png": "9bda",
	"./hero/undraw_6.svg": "893b",
	"./hero/undraw_education_f8ru.svg": "709d",
	"./hero/undraw_teaching_re_g7e3.svg": "054d",
	"./icons/json_evo.png": "6e71",
	"./icons/moodle.png": "f114",
	"./logo.png": "cf05",
	"./participationStateIcons": "1954",
	"./participationStateIcons.ts": "1954",
	"./thumbnails/archive-2.png": "284f",
	"./thumbnails/archive.png": "e24e",
	"./thumbnails/code.png": "bfc5",
	"./thumbnails/text-2.png": "12a7",
	"./thumbnails/text.png": "1442",
	"./thumbnails/video.png": "5544",
	"./unipi.png": "ca71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";